import Table from './Table'
import TableSkeleton from './TableSkeleton'

export { TableSkeleton }
export default Table
